import get from "lodash/get";

/**
 * is_notルールと同じようなチェックが実施される
 * 異なる点は比較対象を値ではなくフィールドで指定すること
 * エラーメッセージも比較対象フィールド名が使用される
 * 比較対象がオブジェクト型の場合、オブジェクトパスを引数で渡してもらい、指定した値を判定する
 * 注意：valueとtargetのいずれかオブジェクト型の場合、pathが必須
 */
export default {
  validate(
    value: string | undefined | null | number | Object,
    { target, path }: { target: unknown; path?: string }
  ): boolean {
    if (value === undefined || value === null || value === "") {
      return true;
    }
    if ((typeof value === "object" || typeof target === "object") && !path) {
      return true;
    }
    const originalValue = typeof value === "object" ? get(value, path!) : value;
    const targetValue =
      typeof target === "object" ? get(target, path!) : target;
    return originalValue !== targetValue;
  },
};
